import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, adminOnly = false, blockReader = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="min-h-screen bg-tw-black flex items-center justify-center">
        <div className="font-mono text-tw-muted text-sm tracking-wider" data-testid="auth-loading">
          AUTHENTICATING...
        </div>
      </div>
    );
  }

  if (user === null) return <Navigate to="/login" replace state={{ from: location }} />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  // Lezers are read-only: keep them out of record/kluis/admin, always land on the library.
  if (blockReader && user.role === "lezer") return <Navigate to="/bibliotheek" replace />;

  return children;
}
